import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';
import { makeSimpleLinkValidator } from 'CorePackage/MainModule/validators/isValidSimpleLink';
import { makeNoSoonerThenValidator } from 'CorePackage/MainModule/validators/isNoSoonerThan';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, DATE_FORMAT_LONG_MINUTE_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import {
  isPhotoTypeDocConfirmationViolation,
  isVideoTypeDocConfirmationViolation,
} from 'KnmErknmPackage/MainModule/common/isTypeDocConfirmationViolationCode';
import { getArrayError } from 'CorePackage/MainModule/common/getArrayError';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';

import { IKnmErknmViolationEvidence } from '../interfaces/IKnmErknmViolationEvidence';

export const getViolationEvidencesValidator = (
  isViolationEvidenceExists: boolean,
  isOnlyLink?: boolean,
  holdingDateTime?: string,
  isDecision?: boolean,
  hasPassportEvents?: boolean,
) => (
  violationEvidenceValues: IKnmErknmViolationEvidence[] | undefined,
): FormErrors<IKnmErknmViolationEvidence>[] | undefined => {
  return violationEvidenceValues?.map(item => {
    const isPhoto = isPhotoTypeDocConfirmationViolation(item.typeDocConfirmationViolation?.code);
    const isVideo = isVideoTypeDocConfirmationViolation(item.typeDocConfirmationViolation?.code);

    return {
      eventOption:
        isDecision && isViolationEvidenceExists && hasPassportEvents
          ? makeRequired('Поле не может быть пустым')(item.eventOption)
          : undefined,
      typeDocConfirmationViolation:
        isDecision && isViolationEvidenceExists
          ? makeRequired('Поле не может быть пустым')(item.typeDocConfirmationViolation)
          : undefined,
      date:
        !isOnlyLink && isViolationEvidenceExists
          ? composeValidators(
              makeRequired('Поле не может быть пустым'),
              ...(holdingDateTime
                ? [
                    makeNoSoonerThenValidator(
                      'Дата фиксации не может быть раньше даты начала проведения акта',
                      () =>
                        formatDate({
                          date: holdingDateTime,
                          dateFormat: DATE_FORMAT_LONG_FNS,
                          parseFormat: DATE_FORMAT_LONG_MINUTE_FNS,
                        }),
                      DATE_FORMAT_LONG_FNS,
                    ),
                  ]
                : []),
            )(item.date)
          : undefined,
      description:
        !isOnlyLink && isViolationEvidenceExists
          ? makeRequired('Поле не может быть пустым')(item.description)
          : undefined,
      link:
        isViolationEvidenceExists && (!isDecision || isVideo)
          ? composeValidators(
              makeRequired('Поле не может быть пустым'),
              makeSimpleLinkValidator('Ссылка имеет некорректный формат'),
            )(item?.link)
          : undefined,
      attachments:
        isDecision && isViolationEvidenceExists && isPhoto && !item.attachments?.length
          ? getArrayError(REQUIRED_ERROR)
          : undefined,
    };
  });
};
